import React from "react";
import { Alert } from "antd";
import { Icon } from "Components";

interface CampaignLimitToastProps {
    visible: boolean;
    message: string;
    onClose: () => void;
    type?: "success" | "warning";
}

const CampaignLimitToast: React.FC<CampaignLimitToastProps> = ({
    visible,
    message,
    onClose,
    type = "warning",
}) => {
    if (!visible) return null;
    return (
        <Alert
            message={message}
            type={type}
            showIcon
            closable
            onClose={onClose}
            icon={<Icon type="campaignInfo" />}
            closeText={<Icon type="close" />}
            className={`campaign-limit-toast ${type}`}
        />
    );
};

export default CampaignLimitToast;